import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'confirmation-text',
  template: require('./confirmation.text.component.html')
})
export class ConfirmationTextComponent {
  @Input() message: string;
  @Input() phrase : string;

  value = '';

  constructor (
    public activeModal: NgbActiveModal
  ) {}

  confirm () : void {
    if ( this.value === this.phrase ) {
      this.activeModal.close();
    }
  }
}
